'use strict';

yalwa.dol_faq = (function(pub) {

	let $view_details;
	let $view_overview;
	let $view_form;
	const rn_config = {type: 'highlight', color: 'yellow', padding: 0, strokeWidth: 1};
	
	pub = pub || {};

	pub.init = function() {
		
		$view_details = jQuery('.js-faq_details');
		$view_overview = jQuery('.js-faq_overview');
		$view_form = jQuery('.js-faq_form');
		
		jQuery('.js-faq_section_head').on('click', faq_section_click);
		jQuery('.js-faq_question').on('click', question_click);
		jQuery('.js-faq_details_answer').on('click', 'a', function(e) {
			if (jQuery(this).attr('href') === '#contact') {
				open_form();
				e.preventDefault();
			}
		});
		var one = false;
		jQuery('.js-faq_search').on('change enterdown search', function() {
			if (!one) { // race condition, throwing multiple requests sometimes
				yalwa.basics.set_get({search: jQuery('.js-faq_search').val()}, true, true);
				one = true;
			}
		});
		jQuery('.js-faq_contact').on('click', open_form);
		jQuery('.js-faq_contact a').on('click', function(e) {
			e.preventDefault();
		});
		jQuery('.js-faq_details_back').on('click', details_back);
		jQuery('.js-faq_rate_positive,.js-faq_rate_negative').on('click', rate);
		jQuery('.js-faq_contact_submit').on('click', contact_submit);
		jQuery('.js-faq_form_back').on('click', () => {
			overview_show();
			yalwa.basics.state.try_cancel('faw_form');
		});
		yalwa.basics.state.register('faq_details', function() {
			if (!$view_details.hasClass('hidden')) {
				overview_show();
				return true;
			}
		});
		yalwa.basics.state.register('faq_form', function() {
			if (!$view_form.hasClass('hidden')) {
				overview_show();
				return true;
			}
		});
		calc_size();
		jQuery(window).on('resize', calc_size);
		jQuery('.js-dol_faq').velocity('fadeIn', {
			delay: 400,
			duration: 600,
			begin: () => {
				yalwa.basics.show(jQuery('.js-dol_faq'));
				if (yalwa.basics.get_get('id')) {
					const $q = jQuery('.js-faq_question').filter('[data-id="' + yalwa.basics.get_get('id') + '"]');
					if ($q.length) {
						$q.trigger('click');
						yalwa.basics.state.push('faq_details');
					}
				}
			},
			complete: () => {
				if (yalwa.basics.get_get('search')) {
					jQuery('.js-faq_question .js-faq_highlight').each((i, e) => {
						RoughNotation.annotate(e, rn_config).show();
					});
				}
			}});
		show_category();
	};
	
	function calc_size() {
		jQuery('.js-dol_faq').css({height: jQuery(window).height() - jQuery('.js-mbody > header').height()});
	}
	
	function contact_submit() {
		const email = jQuery('.js-faq_contact_email').val();
		const message = jQuery('.js-faq_contact_description').val();
		if (!email) {
			jQuery('.js-faq_contact_email').closest('.js-ali').velocity('callout.shake');
			return;
		}
		if (!message) {
			jQuery('.js-faq_contact_description').velocity('callout.shake');
			return;
		}
		jQuery('.faq_contact_submit').attr('disable', true);
		yalwa.mobile.yli.toggle(jQuery('.js-faq_contact_submit'));
		yalwa.basics.ajaxservice({
			resource: 'general',
			action: 'faq_contact',
			type: 'post',
			csrf: jQuery('.js-faq_form').data('faq_contact_csrf'),
			data: {
				email: email,
				category: jQuery('.js-faq_contact_topic').val(),
				section: $view_details.data('current_question_id'),
				message: message
			},
		}).then(contact_submit_response);
	}
	
	function contact_submit_response(response) {
		yalwa.mobile.yli.toggle(jQuery('.js-faq_contact_submit'));
		if (response.success) {
			yalwa.dol.toast({message: response.message, type: 'success'});
			overview_show();
			jQuery('.js-faq_contact_email').val('');
			jQuery('.js-faq_contact_description').val('');
		} else {
			jQuery('.faq_contact_submit').attr('disable', false);
			if (response.invalid_email) {
				yalwa.dol.toast({message: response.invalid_email, type: 'error'});
				jQuery('.js-faq_contact_email').closest('.js-ali').velocity('callout.shake');
			}
			if (response.invalid_message) {
				yalwa.dol.toast({message: response.invalid_message, type: 'error'});
				jQuery('.js-faq_contact_description').velocity('callout.shake');
			}
			if (response.message) { // captcha, rate limiting
				yalwa.dol.toast({message: response.message, type: 'error'});
			}
		}
	}
	
	function rate() {
		const $this = jQuery(this);
		const positive = $this.hasClass('js-faq_rate_positive');
		yalwa.basics.ga.event({
			category: 'dol_faq',
			action: positive ? 'rating helpful' : 'rating not_helpful',
			label: $view_details.data('current_question_id'),
		});
		if (positive) {
			yalwa.basics.hide(jQuery('.js-faq_rate_toggle'));
			yalwa.basics.show(jQuery('.js-faq_rate_success'));
		} else {
			const ID = $view_details.data('current_question_id');
			const level1 = jQuery('.js-faq_question').filter('[data-id="' + ID + '"]').closest('.js-faq_section_body').data('level');
			jQuery('.js-faq_contact_topic').val(level1);
			open_form();
		}
	}
	
	function overview_show() {
		yalwa.basics.hide($view_form);
		yalwa.basics.hide($view_details);
		yalwa.basics.show(jQuery('.js-faq_overview'));
		scroll_restore();
		yalwa.basics.set_get({id: null});
	}
	
	function show_category() {
		if(yalwa.basics.get_get('c')){
			let $cat_wrapper = ('.js-faq_section[data-cat="'+yalwa.basics.get_get('c')+'"]');
			let $plus_icon = $cat_wrapper + ' > .js-faq_section_head > .js-faq_icon_plus';
			let $header = $cat_wrapper + ' > .js-faq_section_head';
			let $close_icon = $cat_wrapper + ' > .js-faq_section_head > .js-faq_icon_close';
			let $body = $cat_wrapper + ' > .js-faq_section_body';
			yalwa.basics.show(jQuery($body));
			yalwa.basics.show(jQuery($close_icon));
			yalwa.basics.hide(jQuery($plus_icon));
			jQuery($header).css({'font-weight':'bold'});
		}
	}
	
	function details_back() {
		overview_show();
		yalwa.basics.state.try_cancel('faq_details');
	}
	
	function scroll_restore() {
		if (yalwa.basics.ls_get('faq_scroll') !== null) {
			jQuery('.js-dol_faq').scrollTop(yalwa.basics.ls_get('faq_scroll'));
		}
	}
	
	function scroll_remember() {
		yalwa.basics.ls_set('faq_scroll', jQuery('.dol_faq').scrollTop());
	}
	
	function details_show() {
		scroll_remember();
		yalwa.basics.hide($view_overview);
		yalwa.basics.show(jQuery('.js-faq_rate_toggle'));
		yalwa.basics.hide(jQuery('.js-faq_rate_success'));
		yalwa.basics.show($view_details);
		yalwa.basics.state.push('faq_details');
		yalwa.basics.set_get({id: $view_details.data('current_question_id')});
		yalwa.basics.ga.event({
			category: 'dol_faq',
			action: 'question_clicked',
			label: $view_details.data('current_question_id'),
		});
		
		//Track only photo duel questions in data layer
		let id = $view_details.data('current_question_id');
		if(id.charAt(0) === 'f') {
			const config = {
				'players_gender': parseInt(yalwa.v.gender) || parseInt(0),
				'players_status': parseInt(yalwa.v.dol_profile_status) || parseInt(0),
				'faq_question': (id.charAt(1)) ? parseInt(id.charAt(1)-1) : parseInt(-1)
			};
			yalwa.basics.datalayer_push({event: 'photo_duel_faq_click', data: config});
		}
		// yalwa.basics.ga.pageview({'page': 'dol_faq/' + $view_details.data('current_question_id')});
	}
	
	function open_form() {
		yalwa.basics.hide($view_overview);
		yalwa.basics.hide($view_details);
		yalwa.basics.show($view_form);
		yalwa.basics.state.push('faq_form');
		yalwa.basics.ga.event({
			category: 'dol_faq',
			action: 'contact_form_opened',
		});
		// yalwa.basics.ga.pageview({'page': 'dol_faq/contact'});
	}
	
	function faq_section_click() {
		const $s = jQuery(this).closest('.js-faq_section');
		const $b = $s.find('.js-faq_section_body');
		yalwa.basics.toggle($b);
		if ($b.hasClass('hidden')) {
			yalwa.basics.hide($s.find('.js-faq_icon_close'));
			yalwa.basics.show($s.find('.js-faq_icon_plus'));
		} else {
			yalwa.basics.hide($s.find('.js-faq_icon_plus'));
			yalwa.basics.show($s.find('.js-faq_icon_close'));
		}
	}
	
	function question_click() {
		const $i = jQuery(this).closest('.js-faq_item');
		const $a = $i.find('.js-faq_answer');
		const $q = $i.find('.js-faq_question');
		$view_details.find('.js-faq_details_question').html($q.html());
		jQuery('.rough-annotation').remove();
		$view_details.find('.js-faq_details_answer').html($a.html());
		$view_details.data('current_question_id', $q.data('id'));
		details_show();
		if (yalwa.basics.get_get('search')) {
			$view_details.find('.js-faq_highlight').each((i, e) => {
				RoughNotation.annotate(e, rn_config).show();
			});
		}
		jQuery('.js-dol_faq').scrollTop(0);
	}
	
	return pub;

}(yalwa.dol_faq));

yalwa.basics.init_wrapper(yalwa.dol_faq.init);